// src/components/AnalyticsProvider.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from '../utils/analytics';

const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;

const AnalyticsProvider = () => {
  const location = useLocation();

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (consent === 'accepted' && measurementId) {
      initGA(measurementId);
    }
  }, []);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (consent === 'accepted') {
      trackPageView(location.pathname);
    }
  }, [location]);

  return null; // Kein UI, nur Tracking
};

export default AnalyticsProvider;
